// extracted by mini-css-extract-plugin
export default {"search-item":"SearchItem_search-item__iTGKn","search-item-title":"SearchItem_search-item-title__CiCjd","search-item-img":"SearchItem_search-item-img__HTHdo"};